export default __webpack_public_path__ + "source-sans-pro-v13-latin_latin-ext-regular.c223f6a7fb3cfc96b4e1.woff2";